import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { ActionSelect } from '../../../Action'

function NewsboardPostProfileActionsWidgetServiceRequestButton({
  Icon,
  className,
  dropdownPlacement,
  options,
  qaName,
  tooltip,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  onSelectOption,
}) {
  return (
    <ActionSelect
      actions={options}
      className={className}
      controlProps={{
        buttonProps: {
          beforeIconProps: { Icon },
          qaName,
          tooltip,
          tooltipPlacement,
        },
      }}
      dropdownFloatingConfig={{
        dropdownStyles: { maxWidth: 'none' },
        placement: dropdownPlacement,
      }}
      listProps={{
        headerProps: { Search: null },
      }}
      onClickAction={onSelectOption}
    />
  )
}

export default NewsboardPostProfileActionsWidgetServiceRequestButton
